// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"3f01346a","974":"28587457"}[chunkId] + ".chunk.js";
};